var _defs, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 737 411",
    width: 737,
    height: 411,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)",
      contentVisibility: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_94"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 737,
    height: 411,
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L737,0 L737,411 L0,411z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_94)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_96)",
    transform: "matrix(10.739999771118164,0,0,10.739999771118164,-3589.18994140625,-2001.570068359375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.8749226331710815,0,0,1,368.5,205.5)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,125,231)",
    fillOpacity: 1,
    d: " M5.5,-16.5 C5.5,-16.5 -13.375,16.625 -13.375,16.625 C-13.375,16.625 -6.75,16.625 -6.75,16.625 C-6.75,16.625 12.5,-16.375 12.5,-16.375 C12.5,-16.375 5.5,-16.5 5.5,-16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(46,125,231)",
    strokeOpacity: 1,
    strokeWidth: 0,
    d: " M5.5,-16.5 C5.5,-16.5 -13.375,16.625 -13.375,16.625 C-13.375,16.625 -6.75,16.625 -6.75,16.625 C-6.75,16.625 12.5,-16.375 12.5,-16.375 C12.5,-16.375 5.5,-16.5 5.5,-16.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,381.5809326171875,192.1389923095703)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,9.593999862670898,6.716000080108643)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(51,155,252)",
    fillOpacity: 1,
    d: " M-9.343999862670898,-6.466000080108643 C-9.343999862670898,-6.466000080108643 -1.628000020980835,6.466000080108643 -1.628000020980835,6.466000080108643 C-1.628000020980835,6.466000080108643 9.343999862670898,6.466000080108643 9.343999862670898,6.466000080108643 C9.343999862670898,6.466000080108643 1.6239999532699585,-6.466000080108643 1.6239999532699585,-6.466000080108643 C1.6239999532699585,-6.466000080108643 -9.343999862670898,-6.466000080108643 -9.343999862670898,-6.466000080108643z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,9.593999862670898,19.64699935913086)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,125,231)",
    fillOpacity: 1,
    d: " M-9.343999862670898,6.466000080108643 C-9.343999862670898,6.466000080108643 1.628000020980835,6.466000080108643 1.628000020980835,6.466000080108643 C1.628000020980835,6.466000080108643 9.343999862670898,-6.460999965667725 9.343999862670898,-6.460999965667725 C9.343999862670898,-6.460999965667725 -1.621999979019165,-6.466000080108643 -1.621999979019165,-6.466000080108643 C-1.621999979019165,-6.466000080108643 -9.343999862670898,6.466000080108643 -9.343999862670898,6.466000080108643z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,335.5525817871094,192.13900756835938)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,9.593999862670898,6.716000080108643)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(46,125,231)",
    fillOpacity: 1,
    d: " M-1.6230000257492065,-6.466000080108643 C-1.6230000257492065,-6.466000080108643 -9.343999862670898,6.466000080108643 -9.343999862670898,6.466000080108643 C-9.343999862670898,6.466000080108643 1.6269999742507935,6.466000080108643 1.6269999742507935,6.466000080108643 C1.6269999742507935,6.466000080108643 9.343999862670898,-6.466000080108643 9.343999862670898,-6.466000080108643 C9.343999862670898,-6.466000080108643 -1.6230000257492065,-6.466000080108643 -1.6230000257492065,-6.466000080108643z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,9.593999862670898,19.649999618530273)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(51,155,252)",
    fillOpacity: 1,
    d: " M-9.343999862670898,-6.461999893188477 C-9.343999862670898,-6.461999893188477 -1.628000020980835,6.4670000076293945 -1.628000020980835,6.4670000076293945 C-1.628000020980835,6.4670000076293945 9.343999862670898,6.4670000076293945 9.343999862670898,6.4670000076293945 C9.343999862670898,6.4670000076293945 1.621999979019165,-6.4670000076293945 1.621999979019165,-6.4670000076293945 C1.621999979019165,-6.4670000076293945 -9.343999862670898,-6.461999893188477 -9.343999862670898,-6.461999893188477z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.3f29305890a0a56309f3dc1638b1c461.svg";
export { ForwardRef as ReactComponent };